import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ScrollText } from "lucide-react";
import DailyTasks from "@/components/DailyTasks";

export default function QuestsPanel({ ch, setCh }) {
  const { t } = useTranslation();
  const [quests, setQuests] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => { api.quests().then(setQuests); }, []);

  const attempt = async (id) => {
    if (busy) return;
    setBusy(true);
    try {
      const res = await api.attemptQuest(id);
      setCh(res.character);
      if (res.success) toast.success(t("quests.success", { roll: res.roll }));
      else toast.error(t("quests.fail", { roll: res.roll }));
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("common.failed"));
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-2">
      <DailyTasks ch={ch} setCh={setCh} />
      <div className="panel p-3">
        <div className="font-heading text-xs tracking-[0.3em] uppercase text-[#8c8c8c]">{t("quests.daily")}</div>
        <div className="font-mono text-[10px] text-[#8c8c8c] mt-1">
          {t("quests.qp", { current: ch.quest_points, max: ch.max_quest_points })}
        </div>
      </div>
      {quests.map(q => {
        const statVal = ch.stats[q.stat];
        const target = q.difficulty + 10;
        return (
          <div key={q.id} className="panel p-3" data-testid={`quest-${q.id}`}>
            <div className="flex items-start gap-2">
              <ScrollText className="w-4 h-4 text-[#B89C3A] mt-1" strokeWidth={1.5} />
              <div className="flex-1">
                <div className="font-heading text-sm text-[#E2DFD8]">{q.name}</div>
                <div className="italic text-xs text-[#8c8c8c] mt-1">{q.text}</div>
                <div className="font-mono text-[10px] text-[#666] mt-1 uppercase tracking-widest">
                  {q.stat}: {statVal} vs {target} · {t("quests.cost", { qp: q.qp_cost })}
                </div>
                <div className="font-mono text-[10px] text-[#E5C34A] mt-1">
                  +{q.reward_gold}g · +{q.reward_xp} xp
                </div>
              </div>
              <button
                data-testid={`quest-attempt-${q.id}`}
                onClick={() => attempt(q.id)}
                disabled={busy || ch.quest_points < q.qp_cost}
                className="px-2 py-1 text-[10px] font-heading tracking-widest uppercase border border-[#333] hover:border-[#E55A00] text-[#E55A00] disabled:opacity-30"
              >
                {t("quests.attempt")}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
